module.exports = __webpack_public_path__ + "img/first-block-logo-mobile.574abeb8.svg";